<script>
  import Button from '../../components/Button'
  import ImageGallery from '../../components/ImageGallery'
  import ImageThumbnailGallery from '../../components/ImageThumbnailGallery'

  export let entry
  export let pageHeading = false
  export let showDate = true
  export let useInlineGallery = true
  export let showHeading = true

  const VIEWS = {
    CONTENT: 'content',
    GALLERY: 'gallery'
  }

  $: contentAvailable = entry.content && entry.content.length > 0
  $: galleryAvailable = entry.images.length > 0

  $: view = (useInlineGallery && galleryAvailable && !contentAvailable) ? VIEWS.GALLERY : VIEWS.CONTENT
  $: showViewToggle = useInlineGallery && galleryAvailable && contentAvailable
  $: showHeader = showHeading || showViewToggle
  $: entryParas = entry?.content.split('\n\n') ?? []

  const toggleView = () => {
    view = view === VIEWS.CONTENT ? VIEWS.GALLERY : VIEWS.CONTENT
  }
</script>

<div class="entry-content">
  {#if showDate && entry.date}
    <p class="h4 entry-date">{entry.localDate}</p>
  {/if}

  {#if showHeader}
  <div class="header">
      {#if showHeading && pageHeading}
        <h1 class="h2 heading">{entry.title}</h1>
      {:else if showHeading}
        <h3 class="heading">{entry.title}</h3>
      {/if}

      {#if showViewToggle}
        <Button on:click={toggleView} variant="secondary-outline">
          View { view === VIEWS.CONTENT ? 'gallery' : 'content'}
        </Button>
        {/if}
  </div>
  {/if}

  {#if view === VIEWS.CONTENT}
    {#if galleryAvailable}
      <div class="thumbnail-gallery-container">
        <ImageThumbnailGallery images={entry.images} galleryLink={!useInlineGallery} />
      </div>
    {/if}
    {#each entryParas as para}
    <p class="prose">{para}</p>
    {/each}
  {/if}

  {#if view === VIEWS.GALLERY}
      <ImageGallery images={entry.images} />
  {/if}
</div>

<style>
  .entry-content {
    max-width: var(--media-md);
    margin: 0 auto;

    display: flex;
    flex-direction: column;
    gap: var(--spacer-lg);
  }

  .entry-content :first-child {
    margin-block-start: 0;
    padding-block-start: 0;
  }

  .entry-content :last-child {
    margin-block-end: 0;
    padding-block-end: 0;
  }

  .thumbnail-gallery-container {
    width: 100%;
    height: 6rem;
  }

  .entry-date {
    margin: 0;
  }

  .header {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: var(--spacer-xl);
  }

  .header .heading {
    flex-shrink: 1;
    margin-block: 0;
  }

  .prose {
    line-height: var(--line-height-body);
    margin-block: 0;
  }

  :not(.prose) + .prose {
    margin-block-start: 0;
  }
</style>
